import styled from 'styled-components'

// Mesmo corte do InfoPanel, que passa a ocupar 82% da tela abaixo dele.
const SMALL_SCREEN = '(max-width: 430px)'

export const TypeContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
`

interface PillContainerProps {
  type: string
  variant?: 'default' | 'dark'
  $tone?: 'default' | 'adhpInfo'
}

export const PillContainer = styled.div<PillContainerProps>`
  background-color: ${({ type, variant, $tone }) => {
    if (type === 'NOTAMN') {
      return '#28A745'
    }

    if (type === 'NOTAMR') {
      return '#17A2B8'
    }

    if (variant === 'dark') {
      return '#374151'
    }

    if ($tone === 'adhpInfo') {
      return '#35B8DC'
    }
  }};
  padding: 4px;
  border-radius: 5px;
  min-width: 20px;
  min-height: 26px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${SMALL_SCREEN} {
    min-height: 22px;
    padding: 2px 4px;
  }
`

export const PillText = styled.span`
  color: ${({ theme }) => theme?.colors?.neutralL5 ?? '#fcfcfc'};
  font-weight: bold;
  ${({ theme }) => theme.fonts.infoLG}
  white-space: nowrap;

  @media ${SMALL_SCREEN} {
    ${({ theme }) => theme.fonts.infoSM}
  }
`

export const DateTimeText = styled.span`
  color: ${({ theme }) => theme?.colors?.neutralL3 ?? '#d9d9d9'};
  ${({ theme }) => theme.fonts.infoLG}

  @media ${SMALL_SCREEN} {
    ${({ theme }) => theme.fonts.infoSM}
  }
`

export const DateTimeContainer = styled.div`
  margin-left: 12px;

  @media ${SMALL_SCREEN} {
    margin-left: 0;
  }
`

export const IconTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const LimitsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`

export const TextContainer = styled.div`
  margin-bottom: 12px;
`

export const Text = styled.p`
  color: ${({ theme }) => theme?.colors?.neutralL5 ?? '#fcfcfc'};
  ${({ theme }) => theme.fonts.infoLG};
  /* O texto do NOTAM traz tokens longos sem espaço (ex.: "SBAO.OPERACIONAL.CINDACTA"). */
  overflow-wrap: anywhere;

  @media ${SMALL_SCREEN} {
    ${({ theme }) => theme.fonts.infoMD};
  }
`

export const LimitText = styled.span`
  color: ${({ theme }) => theme?.colors?.neutralL3 ?? '#d9d9d9'};
  ${({ theme }) => theme.fonts.infoMD}

  @media ${SMALL_SCREEN} {
    ${({ theme }) => theme.fonts.infoSM}
  }
`

export const PeriodContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`
